import React from "react";
import { Handle, Position } from "reactflow";
import { AddStageNodeProps } from "../helpers/workflow.types";


/* ----------------------------------
   Component
---------------------------------- */

const AddStageNode: React.FC<AddStageNodeProps> = ({ data }) => {
  return (
    <div
      onClick={data.onAdd}
      style={{
        width: 180,
        height: 60,
        borderRadius: 6,
        border: "2px dashed #0d6efd",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        background: "#f8f9fa",
        fontWeight: 600,
        color: "#0d6efd",
      }}
    >
      <i className="ri-add-line me-1" />
      Add Stage

      <Handle type="target" position={Position.Top} />
    </div>
  );
};

export default AddStageNode;
